var _circle, _path, _rect, _path2, _path3, _circle2, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightNoMinBundle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    transform: "rotate(13 39.746 24.878)",
    fill: "url(#fdsvtgg5fa)",
    d: "M39.746 24.878h20.058v36.521H39.746z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.484,
    y: 22.637,
    width: 25,
    height: 39,
    rx: 5.5,
    transform: "rotate(13 36.484 22.637)",
    stroke: "url(#mmovrwhodb)",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#6AC34B",
    d: "m56.69 29.128 2.923.675-8.191 35.481-2.923-.674z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.07 51.551 22.374 5.33",
    stroke: "url(#gjo2hfj79c)",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.278,
    cy: 58.196,
    r: 1.5,
    transform: "rotate(13 41.278 58.196)",
    fill: "#0FBDB6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.692,
    y: 29.299,
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(13 45.692 29.299)",
    fill: "#51C244"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fdsvtgg5fa",
    x1: 49.615,
    y1: 23.271,
    x2: 50.678,
    y2: 61.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mmovrwhodb",
    x1: 48.608,
    y1: 24.436,
    x2: 48.608,
    y2: 60.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gjo2hfj79c",
    x1: 46.004,
    y1: 38.34,
    x2: 42.239,
    y2: 54.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNoMinBundle);
export default __webpack_public_path__ + "static/media/lightNoMinBundle.375a4e6bf2df104bb42665fc95f3bc6c.svg";
export { ForwardRef as ReactComponent };